module.exports = "Bienvenido al primer nodo DAPNET en EA"


//////////////////
// WEBPACK FOOTER
// ./src/store/config/defaultText.json
// module id = 7S5r
// module chunks = 1